import React from 'react';
import joinClassNames from '../../functions/joinClassNames';

export function Card({className, children}) {
  return <div className={joinClassNames('p-3 rounded-xl', className)}>{children}</div>;
}
